import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { environment } from '../../../environments/environment';
import { AppConfig, Facet, FacetValue, SearchCriteria, FacetSearchCriteria, FacetRenderMode } from "../webapi/faceted-search-app.model";
import { FacetedSearchAppService } from "../webapi/faceted-search-app.service";

@Component({
  selector: 'admin-facets',
  templateUrl: './admin-facets.component.html',
  styleUrls: ['./admin-facets.component.css']
})


export class AdminFacetsComponent implements OnInit {

  @Output()
  onChange = new EventEmitter<Facet[]>();

  facets: Facet[];

  constructor(private facetedSearchAppService: FacetedSearchAppService) {
  }

  onReorder(e: any) {
    let displayOrder: number = 1;
    for (let i = 0; i < this.facets.length; i++) {
      this.facets[i].displayOrder = this.facets[i].visible ? displayOrder++ : 0;
    }
    this.facetedSearchAppService.updateFacets(this.facets);
  }

  onFacetVisibleChanged(e: any) {
    this.facetedSearchAppService.updateFacets(this.facets);
  }

  facetRenderModes: FacetRenderMode[];

  onFacetInputModeChanged(e: any) {
    this.facetedSearchAppService.updateFacets(this.facets);
  }

  onFacetConfigChanged(facetConfig: Facet[]) {
    this.onChange.emit(this.facets);
  }

  ngOnInit(): void {
    this.facetedSearchAppService.facets().then(x => {
      this.facets = x;
    });
    this.facetedSearchAppService.facetRenderModes().then(x => {
      this.facetRenderModes = x;
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/fsapplication/admin-facets/admin-facets.component.ts